import {Component, Input, OnInit} from '@angular/core';
import {HttpInterceptorProvider} from "../../../../services/mygreencountry/http.interseptor";
import {ModalController} from "@ionic/angular";
import {SafeResourceUrl, SafeUrl} from "@angular/platform-browser";
import {testComment} from "../../../../types/interfaces";

@Component({
    selector: 'app-view-test',
    templateUrl: './view-test.component.html',
    styleUrls: ['./view-test.component.scss'],
})
export class ViewTestComponent implements OnInit {

    @Input() url: SafeResourceUrl;
    @Input() comment: testComment;
    @Input() html: string;
    @Input() isCountrics: boolean = false;

    constructor(private modalCtrl: ModalController) {
    }

    ngOnInit() {
        console.log(this.isCountrics)
        console.log(this.comment)
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

}
